import DateCell from "@blocks/DateCell";
import { Column } from "react-table";

export default [
    {
        Header: 'Code',
        accessor: 'code',
        width: "100%",
        Cell: ({ row }) => row.original.is_early_bird ? `${row.original.code} (Early Bird)` : row.original.code
    },
    {
        Header: 'Discount',
        accessor: 'discount'
    },
    {
        Header: 'Payments',
        accessor: row => row.payments.length
    },
    {
        Header: 'Until',
        accessor: 'until',
        Cell: DateCell
    }
] as Column<Interfaces.Promo.Includes<"payments">>[]